import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { capsulesApi, Capsule } from '@/services/capsulesApi';
import { CapsuleContentView } from '@/components/capsule-view/CapsuleContentView';
import { CapsuleReactionsView } from '@/components/capsule-view/CapsuleReactionsView';
import styles from './CapsuleDetailPage.module.css';
import W_Loader from '@/components/W_Wrappers/W_Loader/W_Loader';
import W_NotFound from '@/components/W_Wrappers/W_NotFound/W_NotFound';
import {
  CapsuleViewMode,
  defaultCapsuleView,
} from '@/components/capsule-view/constants';

export const CapsuleDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [capsule, setCapsule] = useState<Capsule | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);
  const [selectedView, setSelectedView] =
    useState<CapsuleViewMode>(defaultCapsuleView);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      if (!id) return;
      try {
        const res = await capsulesApi.getCapsule(id);
        if (!mounted) return;
        if (res.success && res.data) {
          setCapsule(res.data);
        } else {
          if (mounted) setCapsule(null);
        }
      } catch {
        if (mounted) setCapsule(null);
      } finally {
        if (mounted) {
          setIsLoading(false);
          const timer = setTimeout(() => {
            setShowLoader(false);
          }, 300);
          return () => clearTimeout(timer);
        }
      }
    };
    void load();
    return () => {
      mounted = false;
    };
  }, [id]);

  const handleViewSelect = (option: CapsuleViewMode) => {
    setSelectedView(option);
  };

  if (showLoader) {
    return <W_Loader isLoading={isLoading} />;
  }

  if (!capsule) {
    return <W_NotFound />;
  }

  return (
    <div className={styles.wrapper}>
      {selectedView === 'content' ? (
        <CapsuleContentView
          capsule={capsule}
          isFullscreen={false}
          selectedView={selectedView}
          onViewSelect={handleViewSelect}
        />
      ) : (
        <CapsuleReactionsView
          capsule={capsule}
          isFullscreen={false}
          selectedView={selectedView}
          onViewSelect={handleViewSelect}
          backgroundMode='tunnel'
        />
      )}
    </div>
  );
};
